"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.CreatePaymentLinkDto = void 0;
var class_validator_1 = require("class-validator");
var currencies_1 = require("../../currencies");
var constants_1 = require("../constants");
var CreatePaymentLinkDto = (function () {
    function CreatePaymentLinkDto() {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "uniqueId");
    __decorate([
        class_validator_1.IsIn(Object.keys(constants_1.PAYMENT_LINK_TYPES)),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "type");
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], CreatePaymentLinkDto.prototype, "paymentDate");
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CreatePaymentLinkDto.prototype, "amount");
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "description");
    __decorate([
        class_validator_1.IsIn(Object.keys(currencies_1.CURRENCY_CODES)),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "currency");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "order");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreatePaymentLinkDto.prototype, "company");
    return CreatePaymentLinkDto;
}());
exports.CreatePaymentLinkDto = CreatePaymentLinkDto;
//# sourceMappingURL=payment-links-create.dto.js.map